<template>
  <!-- change to dynamic-primary color when this will be available -->
  <div
    class="tw-p-0.5 tw-border-2 tw-border-dashed tw-border-dynamic-primary tw-rounded-lg tw-bg-gray-100 tw-w-full tw-z-100 tw-flex tw-flex-col tw-justify-center tw-items-center"
    :class="{ 'tw-h-full': fullHeight }"
  >
    <img
      src="@shared/assets/images/drop-file.svg?inline"
      alt="drop file"
      class="tw-mb-2"
    />

    <div class="tw-text-center">
      <slot name="action">
        <AppText class="tw-ml-1">{{ t('chat.labels.dropFileCSV') }}</AppText>
        <slot> </slot>
      </slot>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

withDefaults(
  defineProps<{
    fullHeight: boolean
  }>(),
  {
    fullHeight: false,
  }
)

const { t } = useI18n()
</script>
